export const COMPLETE_FORM = 'COMPLETE_FORM';

export const GET_FORMS = 'GET_FORMS';

export const GET_FORMS_COMPLETED = 'GET_FORMS_COMPLETED';

export const GET_FORMS_FAILED = 'GET_FORMS_FAILED';

export const MARK_FORMS = 'MARK_FORMS';

export const MARK_FORMS_COMPLETED = 'MARK_FORMS_COMPLETED';

export const MARK_FORMS_FAILED = 'MARK_FORMS_FAILED';
